import http from "@/utils/request";

class MerchantApi {
  listMerchant(data) {
    return http.sendRequest({
      METHOD_NAME: "merchant.list",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  }

  listAllMerchant(data) {
    return http.sendRequest({
      METHOD_NAME: "merchant.listAll",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  }

  addOrModifyMerchant(data) {
    return http.sendRequest({
      METHOD_NAME: "merchant.addOrModify",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  }

  merchantBindEnterprise(data) {
    return http.sendRequest({
      METHOD_NAME: "merchant.bindEnterprise",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  }
}

export default new MerchantApi();
